$(window).ready(function(){
  $(".shopify-policy__title h1:contains('Refund policy')").html("Returns & Exchanges");
  
  
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    
    if ($('.agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of One Hockey to check out.");
      return false;
    }
  });
  
});

